import React, { ReactElement } from 'react';
import theme from './EntityIcon.module.scss';
import { EntityIconProps } from './EntityIcon';

interface StackedIconsProps {
    children: ReactElement<EntityIconProps>[];
}

const StackedIcons = React.forwardRef<HTMLDivElement, StackedIconsProps>(({ children }, ref) => {
    const sizes = React.Children.map(children, (x) => x.props.sizeInPx);
    let maxSize = Math.max(...sizes);

    if (!isFinite(maxSize)) {
        maxSize = 0;
    }

    return (
        <div
            style={{ fontSize: maxSize || undefined, '--size': `${maxSize ? maxSize / 2 : 0}px` } as any}
            className={theme.stack}
            ref={ref}>
            {React.Children.toArray(children).reverse()}
        </div>
    );
});

export default StackedIcons;
